import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Feature`}</h1>
    <p>{`Check if a feature is enabled for a user. A `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and `}<inlineCode parentName="p">{`attributes`}</inlineCode>{` could be optionally supplied.`}</p>
    <h2>{`Hook`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { useFeature } from 'react-tesfy';

const Component = () => {
  const isEnabled = useFeature({ id: 'feature-1' }); // true
  // or
  const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
  const attributes = { countryCode: 'us' };
  const isEnabled = useFeature({
    id: 'feature-1',
    userId,
    attributes
  }); // true
};
`}</code></pre>
    <h2>{`Component`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { Feature } from 'react-tesfy';

const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
const attributes = { countryCode: 'us' };

const Component = () => (
  <Feature id="feature-1" userId={userId} attributes={attributes}>
    {isEnabled => isEnabled ? 'enabled' : 'disabled'}
  </Feature>
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      